import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'localeString',
    standalone: false
})
export class LocaleStringPipe implements PipeTransform {

    transform(value: number){
        return value ? (+value).toLocaleString() : value;
    }
}

@NgModule({
    declarations: [LocaleStringPipe],
    exports: [LocaleStringPipe],
})
export class LocaleStringPipeModule {}
